webpackJsonp([74521965400078],{

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _aboutus = __webpack_require__(83);
	
	var _aboutus2 = _interopRequireDefault(_aboutus);
	
	var _aboutus3 = __webpack_require__(141);
	
	var _aboutus4 = _interopRequireDefault(_aboutus3);
	
	var _aboutus5 = __webpack_require__(108);
	
	var _aboutus6 = _interopRequireDefault(_aboutus5);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vacancies = function (_React$Component) {
		(0, _inherits3.default)(Vacancies, _React$Component);
	
		function Vacancies() {
			(0, _classCallCheck3.default)(this, Vacancies);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Vacancies.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Vacancies.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Vacancies.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Freelance Writer Vacancy \u2013 UvoCorp.com",
					meta: [{ name: "description", content: "We give professional academic writers the opportunity to open your talents and professional growth." }, { property: 'og:title', content: "Freelance Writer Vacancy – UvoCorp.com" }, { property: 'og:description', content: "We give professional academic writers the opportunity to open your talents and professional growth." }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/vacancies.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Freelance Academic Writers Wanted"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-gray inner-center" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "col-sm-push-5 col-sm-7" },
								_react2.default.createElement(
									"p",
									null,
									"Academic life is full of stressful challenges. As a team of highly skilled professionals, we do our best to assist our customers with overcoming the challenges they face. We provide our expertise, which helps them become better and better at their studies. It\u2019s a helping hand that guides people to get their studies right."
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "col-sm-pull-7 col-sm-5" },
								_react2.default.createElement(
									"div",
									{ className: "aboutus_img aboutus_img_1" },
									_react2.default.createElement("img", { src: _aboutus2.default, alt: "Vacancy Image1" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white inner-center" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "col-sm-7" },
								_react2.default.createElement(
									"h3",
									null,
									"Responsibilities:"
								),
								_react2.default.createElement(
									"ul",
									null,
									_react2.default.createElement(
										"li",
										null,
										"Writing projects (3 pages on average) on the basis of thorough and professional research;"
									),
									_react2.default.createElement(
										"li",
										null,
										"Properly citing the material used (no plagiarism);"
									),
									_react2.default.createElement(
										"li",
										null,
										"Following customers\u2019 order instructions."
									)
								),
								_react2.default.createElement(
									"h3",
									null,
									"Benefits:"
								),
								_react2.default.createElement(
									"ul",
									null,
									_react2.default.createElement(
										"li",
										null,
										_react2.default.createElement(
											"strong",
											null,
											"High pay"
										),
										" of at least $5 dollars per page (275 words) for simple projects and $12-$15 for more complex and urgent orders;"
									),
									_react2.default.createElement(
										"li",
										null,
										"Payments to writers are regular (twice a month) and are ",
										_react2.default.createElement(
											"strong",
											null,
											"always on time"
										),
										";"
									),
									_react2.default.createElement(
										"li",
										null,
										_react2.default.createElement(
											"strong",
											null,
											"Flexible working"
										),
										" hours and workload (you determine them yourself);"
									),
									_react2.default.createElement(
										"li",
										null,
										"You work only on the ",
										_react2.default.createElement(
											"strong",
											null,
											"projects you like"
										),
										";"
									),
									_react2.default.createElement(
										"li",
										null,
										_react2.default.createElement(
											"strong",
											null,
											"Vibrant community"
										),
										" of writers (we have a Facebook group and our own online journal);"
									),
									_react2.default.createElement(
										"li",
										null,
										"Availability of ",
										_react2.default.createElement(
											"strong",
											null,
											"learning materials"
										),
										" and tutoring;"
									),
									_react2.default.createElement(
										"li",
										null,
										"Our ",
										_react2.default.createElement(
											"strong",
											null,
											"support team"
										),
										" is available 24/7."
									)
								),
								_react2.default.createElement(
									"h3",
									null,
									"Requirements:"
								),
								_react2.default.createElement(
									"ul",
									null,
									_react2.default.createElement(
										"li",
										null,
										"Excellent written English;"
									),
									_react2.default.createElement(
										"li",
										null,
										"Strong research skills, and interest in self-perfection and learning."
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "col-sm-5" },
								_react2.default.createElement(
									"div",
									{ className: "aboutus_img aboutus_img_2" },
									_react2.default.createElement("img", { src: _aboutus4.default, alt: "Vacancy Image2" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-gray inner-center" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "col-xs-12 vacancy-links" },
								_react2.default.createElement(
									"h2",
									{ className: "inner-left" },
									"\u0421ountries"
								),
								_react2.default.createElement(
									"div",
									{ className: "row" },
									_react2.default.createElement(
										"div",
										{ className: "col-md-6" },
										_react2.default.createElement(
											"h3",
											null,
											"USA"
										),
										_react2.default.createElement(
											"ul",
											null,
											_react2.default.createElement(
												"li",
												null,
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/vacancy-ny.html" },
													"New York"
												)
											),
											_react2.default.createElement(
												"li",
												null,
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/vacancy-la.html" },
													"Los Angeles"
												)
											),
											_react2.default.createElement(
												"li",
												null,
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/vacancy-washington.html" },
													"Washington"
												)
											),
											_react2.default.createElement(
												"li",
												null,
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/vacancy-chicago.html" },
													"Chicago"
												)
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "aboutus-disciplines" },
								_react2.default.createElement(
									"h2",
									{ className: "inner-left" },
									"Disciplines We Have"
								),
								_react2.default.createElement(
									"p",
									{ className: "aboutus-subtitle" },
									"Top disciplines"
								),
								_react2.default.createElement(
									"ul",
									{ className: "col-sm-9" },
									_react2.default.createElement(
										"li",
										{ className: "discipline_16" },
										"English 101"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_6" },
										"Business Studies"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_18" },
										"Management"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_17" },
										"History"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_19" },
										"Nursing"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_20" },
										"Psychology"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_21" },
										"Health Care"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_9" },
										"Economics"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_24" },
										"Education"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_22" },
										"Marketing"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_2" },
										"Communications"
									),
									_react2.default.createElement(
										"li",
										{ className: "discipline_23" },
										"Political Science"
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "aboutus_img aboutus_img_5" },
									_react2.default.createElement("img", { src: _aboutus6.default, alt: "Vacancy Image3" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Vacancies;
	}(_react2.default.Component);
	
	exports.default = Vacancies;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-vacancies-html-js-d934b9f78d0d034dd2fa.js